import React from 'react';
import OrderList from '@/components/order/list';

export default () => <OrderList />;
